import { mapGetters, mapActions } from 'vuex';
import { CALCULATOR_ERROR } from '../../components/Calculator/CalculatorDialogError';
import vehicleVariantDetailsJSON from './json-data/vehicle-variant-details.json';
import QueryVehicleByCatalogId from '../../graphql/queries/QueryVehicleByCatalogId';

export default {
  data() {
    return {
      isFetchVehicleVariantDetailsLoading: false
    };
  },

  computed: {
    ...mapGetters({
      orgProfile: 'theme/getOrgProfile',
      ratebookOrgId: 'theme/ratebookOrgId',
      vehicleVariantDetails: 'vehicleVariantDetails/getVehicleVariantDetails'
    }),

    countryCode() {
      return this.orgProfile?.whiteLabel?.region || 'NZ';
    }
  },

  methods: {
    ...mapActions({
      setApploading: 'app/setAppLoading'
    }),

    formatPrice(value) {
      if (value == null || Number.isNaN(value)) return '';
      return `$${Number(value).toLocaleString('en-AU', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
    },
    /**
     * Pick one ratebook item per catalogVehicleId (for the variants carousel).
     */
    pickVariantsByCatalogId(variants, duration) {
      if (!Array.isArray(variants) || !variants.length) return [];
      const byCatalogId = {};
      variants.forEach((item) => {
        const id = item.catalogVehicleId;
        if (!byCatalogId[id]) byCatalogId[id] = [];
        byCatalogId[id].push(item);
      });
      return Object.values(byCatalogId).map((items) => items.find((i) => i.duration === duration) || items[0]);
    },

    notifyCalculatorError() {
      this.$euiNotifications.emit({ notification: CALCULATOR_ERROR });
    },

    async fetchVehicleVariantDetails(catalogVehicleId) {
      try {
        this.isFetchVehicleVariantDetailsLoading = true;

        //const vehicleVariantDetails = this.loadVehicleVariantDetailsFromJson(catalogVehicleId);
        const vehicleVariantDetails = await this.loadVehicleVariantDetailsFromGql(catalogVehicleId);

        if (!vehicleVariantDetails) {
          this.notifyCalculatorError();
          return null;
        }

        if (!vehicleVariantDetails?.items?.length) {
          // keeping your original behaviour
          this.notifyCalculatorError();
        }

        return vehicleVariantDetails;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[fetchVehicleVariantDetails]', error);
        this.notifyCalculatorError();
        return null;
      } finally {
        this.isFetchVehicleVariantDetailsLoading = false;
      }
    },

    /**
     * Supports common shapes:
     * 1) { generatedAt, facets, ... }
     * 2) { data: { fetchVehicleVariantDetails: { generatedAt, facets } } }
     */
    loadVehicleVariantDetailsFromJson(catalogVehicleId) {
      const json = vehicleVariantDetailsJSON;

      // if you saved the gql-like response shape to file
      const gqlLike = json?.data?.fetchVehicleByCatalogId;
      if (gqlLike) return gqlLike;

      // if you saved the raw object to file
      if (json?.facets) return json;

      return null;
    },

    async loadVehicleVariantDetailsFromGql(catalogVehicleId) {
      this.setApploading(true);

      try {
        const response = await this.$apollo.mutate({
          mutation: QueryVehicleByCatalogId,
          fetchPolicy: 'no-cache',
          client: 'boomiClient',
          variables: {
            searchFilters: {
              countryCode: this.countryCode,
              ratebookOrgId: this.ratebookOrgId,
              catalogVehicleId
            }
          }
        });

        return response?.data?.fetchVehicleByCatalogId || null;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('loadVehicleVariantDetailsFromGql error:', error);
        return null;
      } finally {
        this.setApploading(false);
      }
    }
  }
};
